<template>
  <div>
    <div class="input-group mb-5">
      <input type="text" class="form-control" placeholder="Zoek op trefwoord, bijv. 'Verzekering'"
             aria-label="Recipient's username" aria-describedby="button-addon2" v-model="search">
      <div class="input-group-append">
        <button class="btn btn-secondary px-4" type="button" id="button-addon2" @click="">Zoek</button>
      </div>
    </div>
    <div v-if="items.length === 0">Items laden...</div>
    <div v-else-if="filteredItems.length === 0">Geen resultaten</div>
    <div v-for="(cat) in filteredCategories" :key="cat.id">
      <div class="card-body d-flex justify-content-left align-items-center" @click="cat.active = !cat.active">
        <span class="far" :class="cat.active ? 'fa-minus' : 'fa-plus'"></span>
        <h2 class="ml-3 mb-0 ml-md-5">{{ cat.title }}</h2>
      </div>
      <transition-group v-show="cat.active">
        <div :class="{show: item.active}" class="card card-toggle card-faq cursor-pointer"
             v-for="(item) in filteredItems[cat.id]" :key="item.id" @click="item.active = !item.active">
          <div class="card-body d-flex justify-content-left align-items-center">
            <span class="far" :class="item.active ? 'fa-minus' : 'fa-plus'"></span>
            <h2 class="ml-3 mb-0 ml-md-5">{{ item.title }}</h2>
          </div>
          <transition-slide-toggle>
            <div class="card-footer accordion-body" v-show="item.active">
              <div v-html="item.antwoord"></div>
            </div>
          </transition-slide-toggle>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        text: String
    },
    data() {
        return {
            categories: [],
            items: [],
            search: '',
        }
    },
    created() {
        let that = this;
        this.axios.get('/api/faq')
            .then(function (response) {
                that.categories = _.map(response.data.categories, function (element) {
                    return _.extend({}, element, {active: false});
                });

                that.items = _.map(response.data.items, function (element) {
                    return _.extend({}, element, {active: false});
                });
            })
    },
    computed: {
        filteredCategories() {
            let ids = Object.keys(this.filteredItems).map(id => parseInt(id));

            return this.categories.filter(cat => {
                return ids.indexOf(cat.id) > -1;
            });
        },
        filteredItems() {
            let results = [];
            let toSearch = this.trimString(this.search).toLowerCase();
            if (toSearch === '') {
                results = this.items;
            } else {
                toSearch.split(' ').forEach(s => {
                    for (let i = 0; i < this.items.length; i++) {
                        for (let key in this.items[i]) {

                            // Only search in these keys
                            if (key === 'antwoord' || key === 'title') {
                                if (this.items[i][key].toLowerCase().indexOf(s) > -1) {
                                    if (!this.itemExists(results, this.items[i])) {
                                        results.push(this.items[i]);
                                    }
                                }
                            }
                        }
                    }
                });
            }

            results = _.groupBy(results, item => {
                // dit werkt, maar geen optie voor meerdere categorien
                return item.cats.length ? item.cats[0] : 0;
            });

            return results;
        },
    },
    methods: {
        trimString(s) {
            let l = 0, r = s.length - 1;
            while (l < s.length && s[l] == ' ') l++;
            while (r > l && s[r] == ' ') r -= 1;
            return s.substring(l, r + 1);
        },
        compareObjects(o1, o2) {
            let k = '';
            for (k in o1) if (o1[k] != o2[k]) return false;
            for (k in o2) if (o1[k] != o2[k]) return false;
            return true;
        },
        itemExists(haystack, needle) {
            for (let i = 0; i < haystack.length; i++) {
              if (this.compareObjects(haystack[i], needle)) {
                return true;
              }
            }
            return false;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/components/Faq.vue